import { render, staticRenderFns } from "./RiskAnalysisPanel.vue?vue&type=template&id=10947da7"
import script from "./RiskAnalysisPanel.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports